module.exports = __webpack_public_path__ + "static/media/rm.66f1dc24daf77df0835ee71d8f82ee1f.svg";